const { link } = require('fs');
const { data } = require('jquery');
let throttle = require('lodash/throttle');

function onButtonClick(kpiContainerId, kpiTextId) {
  switchKpiContainers(kpiContainerId);

  switchKpiTexts(kpiTextId);
}

function switchKpiContainers(kpiContainerId) {
  let kpiOneKey = 'kpi-one';
  let kpiTwoKey = 'kpi-two';
  let kpiThreeKey = 'kpi-three';
  let transitionDuration = '2s';

  let kpiOneElement = document.getElementById(kpiOneKey);
  let kpiTwoElement = document.getElementById(kpiTwoKey);
  let kpiThreeElement = document.getElementById(kpiThreeKey);

  switch (kpiContainerId) {
    case kpiOneKey:
      kpiOneElement.style.opacity = 1;
      kpiOneElement.style.transition = transitionDuration;
      kpiTwoElement.style.opacity = 0;
      kpiThreeElement.style.opacity = 0;
      break;
    case kpiTwoKey:
      kpiOneElement.style.opacity = 0;
      kpiTwoElement.style.opacity = 1;
      kpiTwoElement.style.transition = transitionDuration;
      kpiThreeElement.style.opacity = 0;
      break;
    case kpiThreeKey:
      kpiOneElement.style.opacity = 0;
      kpiTwoElement.style.opacity = 0;
      kpiThreeElement.style.opacity = 1;
      kpiThreeElement.style.transition = transitionDuration;
      break;
    default:
      break;
  }
}

let previousText = null;

function switchKpiTexts(kpiTextId) {
  previousText = kpiTextId;

  let kpiOneTextKey = 'kpi-one-text';
  let kpiTwoTextKey = 'kpi-two-text';
  let kpiThreeTextKey = 'kpi-three-text';
  let transitionDuration = '1s';

  let kpiOneText = document.getElementById(kpiOneTextKey);
  let kpiTwoText = document.getElementById(kpiTwoTextKey);
  let kpiThreeText = document.getElementById(kpiThreeTextKey);

  switch (kpiTextId) {
    case kpiOneTextKey:
      kpiOneText.style.position = 'absolute';
      kpiOneText.style.transform = 'translateX(100%)';
      kpiOneText.style.opacity = 0;
      kpiOneText.style.transition = transitionDuration;
      break;
    case kpiTwoTextKey:
      kpiTwoText.style.position = 'absolute';
      kpiTwoText.style.transform = 'translateX(-100%)';
      kpiTwoText.style.opacity = 0;
      kpiTwoText.style.transition = transitionDuration;
      break;
    case kpiThreeTextKey:
      break;

    default:
      break;
  }
}

let helpers = {
  openURLInWindow: function openURLInWindow(url) {
    var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
    var width = 550,
      height = 420,
      winHeight = screen.height,
      winWidth = screen.width;
    var left = Math.round(winWidth / 2 - width / 2);
    var top = 0;
    if (winHeight > height) {
      top = Math.round(winHeight / 2 - height / 2);
    }
    window.open(url, 'intent', windowOptions + ',width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);
  },

  kpiRefreshChart: function kpiRefreshChart(index) {
    var chartContainer = $('#dynamic_chart_' + index);
    var chartContainerURL = chartContainer.data('kpi-url');
    var dataLoaded = chartContainer[0].dataset.loaded === 'true';

    var loadData = function loadData() {
      $.ajax(chartContainerURL).then(function (result) {
        try {
          // new field on the ajax call result set (report config)
          if (!!result.skipCalculation && result.skipCalculation === true) {
          } else {
            result.displayTextRendering = helpers.kpiChartSumOfLabels; // this would generate a sum for all
          }
          result.locale = helpers.reportLanguage();
          chartContainer[0].dataset.loaded = 'true';
          chartContainer.ejChart(result);
        } catch (error) {
          console.error(error);
        }
      });
    };

    // uncomment me if needed
    if (chartContainerURL && !dataLoaded) {
      loadData();
    }
  },

  reportLanguage: function reportLanguage() {
    try {
      var path = window.location.pathname.split('/')[1];
      var locale = path !== 'en' ? path + '-CH' : 'en-US';
      return locale;
    } catch (error) {
      console.error('Unable to get the current report langauge setting de');
      return 'de-CH';
    }
  },

  kpiChartSumOfLabels: function kpiChartSumOfLabels(sender) {
    // check the length of series, if there is only one -> always return the one
    if (sender.model.series.length === 1) {
      // no decimal values, this works
      // var newValue = parseInt(sender.data.text.replace(/[,'.]/g, '').trim(), 10);
      // sender.data.text = newValue.toLocaleString(helpers.reportLanguage());
      var value = 0;
      for (var i = 0; i < sender.model.series.length; i++) {
        value += sender.model.series[i].points[sender.data.pointIndex].y;
      }
      sender.data.location.y = sender.data.location.y - 5;
      sender.data.text = value.toLocaleString(helpers.reportLanguage());

      return;
    }

    // check if all series elements are visible
    var allItemsVisible =
      sender.model.series.filter(function (seriesElement, index, all) {
        return seriesElement.visibility === 'visible';
      }).length === sender.model.series.length;

    if (!allItemsVisible) {
      // show only the current stack value
      return;
    }

    // if all elements are visible calculate the count
    if (sender.data.seriesIndex === sender.model.series.length - 1 && sender.model.series.length > 1) {
      var value = 0;
      for (var i = 0; i < sender.model.series.length; i++) {
        value += sender.model.series[i].points[sender.data.pointIndex].y;
      }
      sender.data.location.y = sender.data.location.y - 5;
      sender.data.text = value.toLocaleString(helpers.reportLanguage());
    } else {
      sender.data.text = '';
    }
  }
};

let swisscom = {
  ourYear: {
    setup: () => {
      let carouselContainers = $('.our-year-carousel');

      carouselContainers.each((index, container) => {
        let carousels = $(container).find('.our-year-carousel-carousel');
        carousels.each((index, c) => {
          let carousel = $(c);

          carousel.slick({
            slidesToShow: 2,
            infinite: false,
            dots: true,
            arrows: false,
            dotsClass: 'custom-slick-dots',
            initialSlide: 0,
            responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false
                }
              },
              {
                breakpoint: 450,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: false
                }
              }
            ]
          });

          let prevButtons = $(container).find('#custom-slick-prev');

          prevButtons.each((index, prev) => {
            $(prev).hide();
            $(prev).on('click', () => carousel.slick('slickPrev'));
          });

          let nextButtons = $(container).find('#custom-slick-next');
          nextButtons.each((index, next) => {
            $(next).on('click', () => carousel.slick('slickNext'));
          });

          carousel.on('afterChange', function (event, slick, currentSlide) {
            swisscom.ourYear.startActiveVideos();

            let isFirstItem = currentSlide === 0;
            let isLastItem = slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;

            prevButtons.each((index, prev) => $(prev).show());
            nextButtons.each((index, next) => $(next).show());

            if (isFirstItem) {
              prevButtons.each((index, prev) => $(prev).hide());
              nextButtons.each((index, next) => $(next).show());
            }
            if (!isFirstItem) {
              prevButtons.each((index, prev) => $(prev).show());
            }
            if (isLastItem) {
              nextButtons.each((index, next) => $(next).hide());
            }
          });
        });
      });

      if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window)) {
      } else {
        var elements = document.getElementsByClassName('our-year-slide__image-video');
        Array.from(elements).forEach(function (element) {
          var observer = new IntersectionObserver(swisscom.ourYear.toggleAnimation, {
            root: null,
            rootMargin: '0px',
            threshold: 0.8
          });
          observer.observe(element);
        });
      }
    },

    toggleAnimation: (entries, observer) => {
      entries.forEach((element) => {
        if (element.intersectionRatio >= 0.8) {
          // console.log('Start video');
          element.target.play();
        } else {
          // console.log('Stop video');
          element.target.pause();
          element.target.currentTime = 0;
        }
      });
    },

    startActiveVideos: () => {
      $('.slick-slide.slick-active video').each((index, element) => {
        element.play();
      });
    }
  },
  carousel: {
    setup: function setup() {
      swisscom.carousel.slick = $('.swisscom-hero__backgrounds');
      swisscom.carousel.slick.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: false,
        appendArrows: false,
        variableWidth: false,
        adaptiveHeight: false,
        touchMove: false,
        draggable: false,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 3000
      });
      swisscom.carousel.slick.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        swisscom.carousel.updateBulletPoints();
      });

      swisscom.carousel.showAll();
      swisscom.carousel.hookupControls();
    },
    leftRightClicked: function leftRightClicked(event) {
      var slickEvents = { prev: 'slickPrev', next: 'slickNext' };
      var direction = event.currentTarget.dataset.carouselSlider;
      swisscom.carousel.slick.slick(slickEvents[direction]);
      swisscom.carousel.updateBulletPoints();
    },
    bulletClicked: function bulletClicked(event) {
      swisscom.carousel.slick.slick('slickGoTo', event.currentTarget.dataset.carouselBullet);
      swisscom.carousel.updateBulletPoints();
    },
    showAll: function showAll() {
      Array.from(document.getElementsByClassName('swisscom-hero__image')).forEach(function (image) {
        return (image.style.display = 'block');
      });
    },
    hookupControls: function hookupControls() {
      // left, right
      Array.from(document.getElementsByClassName(swisscom.carousel.sliderClass)).forEach(function (element) {
        element.addEventListener('click', swisscom.carousel.leftRightClicked);
      });
      // bullet points
      swisscom.carousel.bulletPoints = Array.from(document.getElementsByClassName(swisscom.carousel.bulletClass));
      swisscom.carousel.bulletPoints.forEach(function (element) {
        element.addEventListener('click', swisscom.carousel.bulletClicked);
      });
    },
    updateBulletPoints: function updateBulletPoints() {
      swisscom.carousel.bulletPoints.forEach(function (element, index) {
        element.classList.remove(swisscom.carousel.bulletActiveClass);
        if (swisscom.carousel.slick.slick('slickCurrentSlide') === parseInt(element.dataset.carouselBullet, 10)) {
          element.classList.add(swisscom.carousel.bulletActiveClass);
        }
      });
    },
    bulletClass: 'pagination-bullet-hero',
    bulletActiveClass: 'pagination-bullet--active',
    bulletPoints: [],
    sliderClass: 'swisscom-hero__slider-icon',
    userInterrupted: false,
    waitTime: 5000,
    slick: undefined
  },
  simplebar: {
    setup: function (agenda) {
      new SimpleBar(agenda);
    }
  },
  kpis: {
    setup: function setup() {
      swisscom.kpis.kpiDetails = Array.from(document.getElementsByClassName('swisscom-kpi-details'));
      swisscom.kpis.kpiItems = Array.from(document.getElementsByClassName('swisscom-kpi-item'));
      swisscom.kpis.kpiItems.forEach(function (element) {
        element.addEventListener('click', swisscom.kpis.kpiItemClicked);
      });
      swisscom.kpis.kpiItemsMobile = Array.from(document.getElementsByTagName('sdx-accordion-item'));
      swisscom.kpis.kpiItemsMobile.forEach(function (element) {
        element.addEventListener('click', swisscom.kpis.kpiItemClickedMobile);
      });

      Array.from(document.getElementsByClassName('kpi-category-switcher')).forEach((element) => {
        element.addEventListener('click', (e) => {
          let sectionId = parseInt(e.target.dataset.sectionid, 10);
          swisscom.kpis.showSection(sectionId);
          if (swisscom.kpis.kpisOpened) {
            swisscom.kpis.kpiCollapseDesktop(swisscom.kpis.kpiActiveElement);
          }
        });
      });

      if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window)) {
      } else {
        Array.from(document.getElementsByClassName('swisscom-kpi-item__value'))
          .filter((e) => {
            return e.dataset.sectionid === '0';
          })
          .forEach(function (element) {
            var options = {
              root: null,
              rootMargin: '0px',
              threshold: 1.0
            };

            var observer = new IntersectionObserver(swisscom.kpis.countUp, options);
            observer.observe(element.children[0]);
          });
      }

      Array.from(document.getElementsByClassName('swisscom-kpis__row1')).forEach((val, index) => {
        swisscom.kpis.animation[index] = new TimelineLite({ paused: true })
          .add(swisscom.kpis.expandRowsTween(index), 0)
          .add(swisscom.kpis.moveKpisUp(index), 0.2)
          .add(swisscom.kpis.rotateDetails(index), 0.5);
      });
    },
    showSection: (sectionId) => {
      var animation = swisscom.kpis.animation[swisscom.kpis.affectedKpiSection];

      let switchSection = () => {
        Array.from(document.getElementsByClassName('swisscom-kpi-section')).forEach((e, index) => {
          let showSection = index === sectionId;
          e.classList.remove('visible');
          if (showSection) {
            e.classList.add('visible');
          }
        });

        let elements = Array.from(document.getElementsByClassName('swisscom-kpi-item__value')).filter((e) => {
          return e.dataset.sectionid === '' + sectionId;
        });
        swisscom.kpis.countUp(elements, undefined, true);
      };

      if (swisscom.kpis.kpisOpened) {
        setTimeout(switchSection, 700);
      } else {
        switchSection();
      }
    },
    countUp: function countUp(entries, observer, forceCountUp) {
      entries.forEach(function (element) {
        if (element.intersectionRatio === 1 || forceCountUp === true) {
          var target = forceCountUp ? element.children[0] : element.target;
          var targetValue = parseFloat(target.dataset.to);
          var targetIndex = parseInt(target.dataset.index, 10);
          var targetSeparator = target.dataset.separator;

          // console.log(targetIndex, targetSeparator, targetValue);

          if (target.dataset.animated === 'true' && !forceCountUp) return;

          var options = {
            useEasing: false,
            useGrouping: true,
            separator: targetIndex === 5 ? targetSeparator : undefined,
            decimal: targetIndex !== 5 ? targetSeparator : undefined
          };

          var decimals = !!targetSeparator && targetIndex !== 5 ? 1 : 0;
          var demo = new CountUp(target, 0, targetValue, decimals, 2.0, options);
          if (!demo.error) {
            demo.start();
            target.dataset.animated = 'true';
          } else {
            // console.error("not working");
          }
        }
      });
    },
    kpiItemClickedMobile: function (event) {
      var clickedElement = event.currentTarget;
      var clickedIndex = parseInt(clickedElement.dataset.id, 10);
      var clickedSectionIndex = parseInt(clickedElement.dataset.sectionid, 10);
      setTimeout(function () {
        swisscom.charts.loadChartsIfNeeded(clickedIndex, clickedSectionIndex);
      }, 120);
    },
    kpiItemClicked: function kpiItemClicked(event) {
      var clickedElement = event.currentTarget;
      swisscom.kpis.kpiCollapseDesktop(clickedElement);
    },
    kpiCollapseDesktop: (clickedElement) => {
      var _swisscom$kpis = swisscom.kpis,
        kpiActiveItemIndex = _swisscom$kpis.kpiActiveItemIndex,
        startAnimation = _swisscom$kpis.startAnimation,
        enableKPIItemActiveClass = _swisscom$kpis.enableKPIItemActiveClass;

      var clickedIndex = parseInt(clickedElement.dataset.id, 10);
      var clickedSectionIndex = parseInt(clickedElement.dataset.sectionid, 10);
      swisscom.kpis.affectedKpiSection = clickedSectionIndex;
      var combinedIndex = '' + clickedSectionIndex + clickedIndex;

      swisscom.kpis.hideAllDetails();
      swisscom.kpis.removeActiveClass();

      if (combinedIndex !== kpiActiveItemIndex || kpiActiveItemIndex === undefined) {
        swisscom.kpis.kpiActiveItemIndex = combinedIndex;
        swisscom.kpis.kpiActiveElement = clickedElement;
        swisscom.kpis.showDetail(combinedIndex);
        enableKPIItemActiveClass(clickedElement);
        swisscom.charts.loadChartsIfNeeded(clickedIndex - 1, clickedSectionIndex);
      }

      if (kpiActiveItemIndex === undefined) {
        swisscom.kpis.kpiActiveItemIndex = combinedIndex;
        swisscom.kpis.kpiActiveElement = clickedElement;
        startAnimation(clickedElement);
        enableKPIItemActiveClass(clickedElement);
        swisscom.charts.loadChartsIfNeeded(clickedIndex - 1, clickedSectionIndex);
      }

      if (combinedIndex === kpiActiveItemIndex) {
        swisscom.kpis.kpiActiveItemIndex = undefined;
        swisscom.kpis.kpiActiveElement = undefined;
        startAnimation(clickedElement);
      }
    },
    enableKPIItemActiveClass: function enableKPIItemActiveClass(element) {
      element.classList.add(swisscom.kpis.kpiItemActiveClass);
    },
    startAnimation: function startAnimation(element) {
      var animation = swisscom.kpis.animation[swisscom.kpis.affectedKpiSection];

      animation.reversed(typeof swisscom.kpis.kpiActiveItemIndex === 'undefined');
      if (!animation.reversed()) {
        animation.play(0);
        swisscom.kpis.kpisOpened = true;
      } else {
        animation.reverse(0);
        swisscom.kpis.kpisOpened = false;
        swisscom.kpis.kpiActiveItemIndex = undefined;
      }
    },
    expandRowsTween: function expandRowsTween(sectionIndex) {
      const detailsHeight = Array.from(document.getElementsByClassName('swisscom-kpi-details'))[0].clientHeight;
      const firstRow = Array.from(document.getElementsByClassName('swisscom-kpis__row1'))[0];
      const rowHeight = firstRow.clientHeight;

      const newHeight = rowHeight + detailsHeight / 2.0;

      return new TimelineLite()
        .to(`#swisscom-kpis__row${sectionIndex}1`, 0.1, { height: newHeight }, 0)
        .to(`#swisscom-kpis__row${sectionIndex}2`, 0.1, { height: newHeight }, 0);
    },
    moveKpisUp: function moveKpisUp(sectionIndex) {
      var margin = 216;
      var ease = Circ.easeOut;
      var runtime = 0.3;

      return new TimelineLite(sectionIndex)
        .to(`#swisscom-kpi-${sectionIndex}1`, runtime, { marginBottom: margin, ease: ease }, 0)
        .to(`#swisscom-kpi-${sectionIndex}4`, runtime, { marginTop: margin, ease: ease }, 0)
        .to(`#swisscom-kpi-${sectionIndex}2`, runtime, { marginBottom: margin, ease: ease }, 0.1)
        .to(`#swisscom-kpi-${sectionIndex}5`, runtime, { marginTop: margin, ease: ease }, 0.1)
        .to(`#swisscom-kpi-${sectionIndex}3`, runtime, { marginBottom: margin, ease: ease }, 0.2)
        .to(`#swisscom-kpi-${sectionIndex}6`, runtime, { marginTop: margin, ease: ease }, 0.2);
    },
    rotateDetails: function rotateDetails(sectionIndex) {
      var item = `#kpis-placeholder${sectionIndex}`;
      return new TimelineLite().to(item, 0.3, { transform: 'rotateX(0deg)' }, 0);
    },
    removeActiveClass: function removeActiveClass() {
      swisscom.kpis.kpiItems.forEach(function (kpiItem) {
        kpiItem.classList.remove(swisscom.kpis.kpiItemActiveClass);
      });
    },
    hideAllDetails: function hideAllDetails() {
      swisscom.kpis.kpiDetails.forEach(function (element) {
        element.style.opacity = 0;
        element.style['z-index'] = -100;
      });
    },
    showDetail: function showDetail(index) {
      swisscom.kpis.kpiDetails
        .filter((d) => d.dataset.uniqueid === index)
        .forEach((d) => {
          d.style.opacity = 1;
          d.style['z-index'] = 100;
        });
    },
    animation: {},
    kpisOpened: false,
    affectedKpiSection: undefined,
    kpiItems: [],
    kpiItemsMobile: [],
    kpiItemActiveClass: 'active',
    kpiActiveItemIndex: undefined,
    kpiActiveElement: undefined,
    kpiDetails: []
  },
  charts: {
    currentWidth: undefined,
    setup: function setup() {
      // $(window).resize(_.debounce(swisscom.charts.loadChartsIfNeeded));
      // swisscom.charts.loadChartsIfNeeded();
    },
    loadChartsIfNeeded: function (index, sectionIndex) {
      var screenWidth = document.documentElement.clientWidth;
      swisscom.charts.currentWidth = screenWidth;

      var mobile = [7, 8, 9, 10, 11, 12];
      var desktop = [1, 2, 3, 4, 5, 6];
      var chartsToLoad = screenWidth >= 1024 ? desktop : mobile;
      swisscom.charts.loadCharts([chartsToLoad[index]], sectionIndex);
    },
    loadCharts: function (chartIds, sectionIndex) {
      chartIds.forEach(function (index) {
        helpers.kpiRefreshChart('' + sectionIndex + index);
      });
    }
  },
  share: {
    setup: function () {
      var sharingElement = document.getElementsByClassName('sharing');
      if (sharingElement.length === 0) return;

      var sharingEnabledClasses = ['.icon-font-facebook', '.icon-font-twitter', '.icon-font-xing', '.icon-font-linkedin'];
      var setupJqueryClick = function (className) {
        $(className)
          .parent()
          .on('click', function (event) {
            event.preventDefault();

            var allowClick = (event.currentTarget.dataset.allowclick || event.target.dataset.allowclick || 'false') === 'true';

            if (allowClick === false) {
              console.info('Skipping click');
              return;
            }

            var url = $(event.target).parent().attr('href') || $(event.target).attr('href');

            if (typeof ga === 'function') {
              var splittedClassName = className.split('-');
              var provider = splittedClassName[splittedClassName.length - 1];
              ga('send', 'event', 'Sharing', provider, window.location.toString());
            } else {
              console.log('No GA');
            }

            helpers.openURLInWindow(url);
          });
      };
      sharingEnabledClasses.forEach(function (classToRegister, index, all) {
        setupJqueryClick(classToRegister);
      });

      $('.sharing__icon.toggle').click(function (event) {
        event.preventDefault();
        $('.sharing__links').toggleClass('open');
      });

      swisscom.share.hideOrShow();
      window.addEventListener('scroll', swisscom.share.hideOrShow, { capture: true, passive: true });
      $(window).resize(swisscom.share.hideOrShow);

      window.addEventListener('click', function (event) {
        if (event.target.parentElement && !event.target.parentElement.classList.contains('sharing__icon')) {
          swisscom.share.close();
        }
      });
    },
    hideOrShow: throttle(function (event) {
      if (document.documentElement.clientWidth >= 768) {
        swisscom.share.show();
        return;
      }

      var operation = window.scrollY >= window.innerHeight ? swisscom.share.show : swisscom.share.hide;
      operation();
    }),
    close: function () {
      $('.sharing__links').removeClass('open');
    },
    show: function () {
      Array.from(document.getElementsByClassName('sharing'))[0].classList.add('open');
    },
    hide: function () {
      Array.from(document.getElementsByClassName('sharing'))[0].classList.remove('open');
    }
  },
  videoLoopAutoPlay: {
    setup() {
      const threshold = 0.4;
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: threshold
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((video) => {
          if (video.isIntersecting && video.intersectionRatio >= threshold) {
            video.target.play();
          } else {
            video.target.pause();
            video.target.currentTime = 0;
          }
        });
      }, options);

      const loopVideos = document.querySelectorAll('.video-loop > video');
      Array.from(loopVideos).forEach((el) => {
        observer.observe(el);
      });
    }
  },

  playButtonVideoLoad: {
    loadBehindTheScenesVideo(videoId, autoPlay) {
      const videoElement = document.getElementById(`video-${videoId}`);
      const videoIdElementHtml5 = `video-${videoId}_html5_api`;

      videojs.getPlayer(`video-${videoId}`).ready(function () {
        this.on('loadedmetadata', function () {
          var myPlayer = this;

          const links = Array.from(videoElement.parentElement.parentElement.querySelectorAll('.link'));
          links.forEach((el) => (el.style.opacity = 1));
          const videoOverlay = document.getElementById(`video-controls-${videoId}`);

          window.swisscom = window.swisscom || {};
          window.swisscom['videos'] = window.swisscom['videos'] || {};
          window.swisscom['videos'][`video-${videoId}`] = {
            player: myPlayer,
            start: function (event) {
              event && event.preventDefault();

              const startElement = document.getElementById(videoIdElementHtml5);
              startElement.setAttribute('controls', true);

              startElement.onplay = function () {
                requestAnimationFrame(() => {
                  videoOverlay.style.display = 'none';
                  videoOverlay.style.zIndex = -50;
                });
              };

              startElement.onpause = function () {
                window.swisscom['videos'][`video-${videoId}`].pause();
              };

              myPlayer.play();
            },
            pause: function (immediate) {
              setTimeout(
                function () {
                  const startElement = document.getElementById(videoIdElementHtml5);
                  if (!startElement || startElement.paused) {
                    requestAnimationFrame(() => {
                      videoOverlay.style.removeProperty('display');
                      videoOverlay.style.removeProperty('z-index');
                    });
                  }
                },
                immediate ? 0 : 1500
              );
            }
          };

          if (autoPlay) {
            requestAnimationFrame(() => {
              const cleanedUrl = window.location.href.split('?')[0];
              window.history.replaceState({}, document.title, cleanedUrl);
            });
          }
        });
      });
    },
    setupObserver() {
      const videoContainers = Array.from(document.querySelectorAll(`.video-container.report-2020`));

      const threshold = 0.4;
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: threshold
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((videoContainer) => {
          const containerId = videoContainer.target.dataset.videoId;
          const videoId = `video-${containerId}`;
          const scriptId = `video-script-${containerId}`;
          if (
            videoContainer.isIntersecting &&
            videoContainer.intersectionRatio >= threshold &&
            videoContainer.target.dataset.isLoaded !== 'true'
          ) {
            videoContainer.target.dataset.isLoaded = 'true';
            const video = document.createElement('video');
            video.id = videoId;
            video.setAttribute('playsinline', 'playsinline');
            video.setAttribute('nativeControlsForTouch', true);
            video.classList.add('swisscom-inline-video');
            video.dataset.shortcutId = videoContainer.target.dataset.shortcutId;
            video.dataset.account = '2048251700001';
            video.dataset.player = 'B18YONA7Z';
            video.dataset.embed = 'default';
            video.dataset.videoId = containerId;
            video.style.width = '100%';
            video.style.height = '100%';
            video.style.position = 'absolute';
            video.style.top = 0;
            video.style.left = 0;
            video.style.right = 0;
            video.style.bottom = 0;
            videoContainer.target.appendChild(video);
            var script = document.createElement('script');
            script.setAttribute('id', scriptId);
            script.setAttribute('src', 'https://players.brightcove.net/2048251700001/B18YONA7Z_default/index.min.js');
            script.addEventListener('load', () => {
              const autoPlay = swisscom.playButtonVideoLoad.urlParams()['video'] === videoContainer.target.dataset.shortcutId;
              swisscom.playButtonVideoLoad.loadBehindTheScenesVideo(containerId, autoPlay);
            });
            requestAnimationFrame(() => {
              document.body.appendChild(script);
            });
          } else {
            const settings =
              window.swisscom && window.swisscom.videos && window.swisscom['videos'][videoId]
                ? window.swisscom['videos'][videoId]
                : undefined;
            if (settings) {
              settings.pause(true);
              window.swisscom.videos[`video-${videoId}`] = undefined;
            }
            videoContainer.target.dataset.isLoaded = 'false';
            const scriptElement = document.getElementById(scriptId);
            const videoElement = document.getElementById(videoId);
            window.videojs && window.videojs(videoId).dispose();
            if (videoElement && scriptElement) {
              const links = Array.from(document.getElementById(`video-controls-${containerId}`).querySelectorAll('.controls > .link'));
              links.forEach((el) => (el.style.opacity = 0));
              scriptElement.remove();
              videoElement.remove();
            }
          }
        });
      }, options);
      videoContainers.forEach((videoContainer) => {
        observer.observe(videoContainer);
      });
    },
    urlParams() {
      var match,
        pl = /\+/g, // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) {
          return decodeURIComponent(s.replace(pl, ' '));
        },
        query = window.location.search.substring(1);

      var params = {};
      while ((match = search.exec(query))) params[decode(match[1])] = decode(match[2]);

      return params;
    },

    setup() {
      // check for autoplay

      const videoContainers = Array.from(document.getElementsByClassName(`video-container`));
      if (swisscom.playButtonVideoLoad.urlParams()['video']) {
        videoContainers.forEach((videoContainer) => {
          const scrollIntoView = videoContainer.dataset.shortcutId === swisscom.playButtonVideoLoad.urlParams()['video'];
          if (scrollIntoView) {
            const controlElement = document.getElementById(`video-controls-${videoContainer.dataset.videoId}`);
            setTimeout(() => {
              controlElement.scrollIntoView({ block: 'center', behavior: 'smooth' });
              setTimeout(() => {
                swisscom.playButtonVideoLoad.setupObserver();
              }, 1000);
            }, 0);
          }
        });
      } else {
        swisscom.playButtonVideoLoad.setupObserver();
      }
    }
  }
};

let slider = document.getElementsByClassName('swisscom-hero__backgrounds');
if (slider.length > 0) {
  swisscom.carousel.showAll();
  swisscom.carousel.setup();
}

var agenda = document.getElementById('agenda-overflow');
if (!!agenda) {
  swisscom.simplebar.setup(agenda);
}

// kpis
var kpis = document.getElementsByClassName('swisscom-kpis');
if (kpis.length > 0) {
  swisscom.kpis.setup();
  swisscom.charts.setup();
}

swisscom.share.setup();
swisscom.ourYear.setup();
swisscom.videoLoopAutoPlay.setup();

swisscom.playButtonVideoLoad.setup();
